import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'
import router from '../router'

Vue.use(Vuex);


axios.interceptors.request.use(function (config) {
    // console.log(config)
    return config;
}, function (err) {
    return Promise.reject(err);
});

axios.interceptors.response.use(
    response => {
        return response;
    },
    err => {
        if (err && err.response) {
            // router.push("/Login");
            console.log("err", "連接到服務器失敗");
        } else {
            console.log("連接到服務器失敗");
            //router.push("/Login");
        }
        return Promise.resolve(err.response);
    }
);


const state = {
    auth: {
        url: "demo.igreent.com",
        cust_id: "admin",
        uid: "Admin",
        password: "123456",
    },
    "loginInfo": {
        "Name": "Mike",
        "Accountid": 0,
    },
    loginUID: {
        psw: "",
        superuser: 0
    },
    host: "",
    exec_cust_gateway_000: [],
    exec_uid_gateway_000: [],
    menushow: false,
    menu: [],

};

const getters = {

};

// change status 處理同步函數
const mutations = {
    setLoginInfo(state, loginInfo) {
        state.loginInfo = loginInfo;
    },
    setHost(state, url) {
        if ( document.location.protocol ? true: false)
        {
           state.host = "http://" + url;
         }
        else
        {
            state.host = "http://" + url;
        }
        console.log(state.host);
    },
    setLoginUID(state, loginInfo) {
        state.loginUID = loginInfo;
    },
    setexec_cust_gateway_000(state, data) {
        state.exec_cust_gateway_000 = data;
    },
    setexec_uid_gateway_000(state, data) {
        state.exec_uid_gateway_000 = data;
    },
    setMenuShow(state, data) {
        state.menushow = data;
    },
    setMenu(state, data) {
        state.menu = data;
    },
};


//•	操作同步或異步事件的處理但不直接修改資料（state）
//•	是透過commit → 呼叫 mutation 改變 state
const actions = {
    setLoginInfo(context, loginInfo) {
        context.commit('setLoginInfo', loginInfo);
    },
    setLoginUID(context, loginInfo) {
        context.commit('setLoginUID', loginInfo);
    },
    setHost(context, url) {
        context.commit('setHost', url);
    },
    getlogin(context, form) {
        var url = state.host + "/php/exec_cust_uid_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_gateway_000(context, form) {
        var url = state.host + "/php/exec_cust_gateway_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    context.commit('setexec_cust_gateway_000', data.data);
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_uid_gateway_000(context, form) {
        var url = state.host + "/php/exec_uid_gateway_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    context.commit('setexec_uid_gateway_000', data.data);
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_device_now_v2_000(context, form) {
        var url = state.host + "/php/exec_device_now_v2_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_equip_valname_000(context, form) {
        var url = state.host + "/php/exec_equip_valname_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_log_count_000(context, form) {
        var url = state.host + "/php/exec_log_count_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_log_desc_000(context, form) {
        var url = state.host + "/php/exec_log_desc_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_uid_005(context, form) {
        var url = state.host + "/php/exec_cust_uid_005.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_uid_0061(context, form) {
        var url = state.host + "/php/exec_cust_uid_006.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_uid_003(context, form) {
        var url = state.host + "/php/exec_cust_uid_003.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_uid_007(context, form) {
        var url = state.host + "/php/exec_cust_uid_007.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_uid_001(context, form) {
        var url = state.host + "/php/exec_cust_uid_001.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_uid_002(context, form) {
        var url = state.host + "/php/exec_cust_uid_002.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_uid_gateway_003(context, form) {
        var url = state.host + "/php/exec_uid_gateway_003.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_uid_004(context, form) {
        var url = state.host + "/php/exec_cust_uid_004.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_history_003(context, form) {
        var url = state.host + "/php/exec_history_003.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_history_000(context, form) {
        var url = state.host + "/php/exec_history_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "get",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    ig_pic_001(context, form) {
        var url = state.host + "/php/ig_pic_001.php";
        return new Promise((response, reject) => {
            axios({
                method: "POST",
                url: url,
                data: form,
                headers: {
                    'Content-Type': 'application/json'
                },

            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cust_gateway_001(context, form) {
        var url = state.host + "/php/exec_cust_gateway_001.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_device_now_v2_id_001(context, form) {
        var url = state.host + "/php/exec_device_now_v2_id_001.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_kpi_data_000(context, form) {
        var url = state.host + "/php/exec_kpi_data_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_gw_status(context, form) {
        var url = state.host + "/php/exec_gw_status.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cutter_speed(context, form) {
        var url = state.host + "/php/exec_cutter_speed.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cnc_machine_status(context, form) {
        var url = state.host + "/php/exec_cnc_machine_status.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_equip_id_000(context, form) {
        var url = state.host + "/php/exec_equip_id_000.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    query_table_v2_cg_cutter_reason(context, form) {
        var url = state.host + "/php/query_table_v2.php?tblfield=*&tblname=cg_cutter_reason";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    query_table_v2_cg_cutter_reason_desc(context, form) {
        var url = state.host + "/php/query_table_v2.php?tblfield=*&tblname=cg_cutter_reason_desc%20where%20" + form;
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    do_change_cutter(context, form) {
        var url = state.host + "/php/do_change_cutter.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_cnc_checkout(context, form) {
        var url = state.host + "/php/exec_cnc_checkout.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_byday(context, form) {
        var url = state.host + "/php/exec_solar_byday.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_totgen(context, form) {
        var url = state.host + "/php/exec_solar_totgen.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_build(context, form) {
        var url = state.host + "/php/exec_solar_build.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_efficacy(context, form) {
        var url = state.host + "/php/exec_solar_efficacy.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_byweek(context, form) {
        var url = state.host + "/php/exec_solar_byweek.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_bymonth(context, form) {
        var url = state.host + "/php/exec_solar_bymonth.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_byyear(context, form) {
        var url = state.host + "/php/exec_solar_byyear.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_byhour(context, form) {
        var url = state.host + "/php/exec_solar_byhour.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_solar_general(context, form) {
        var url = state.host + "/php/exec_solar_general.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    exec_gateway_status(context, form) {
        var url = state.host + "/php/exec_gateway_status.php";
        return new Promise((response, reject) => {
            axios({
                method: "GET",
                url: url,
                params: form,
            })
                .then(data => {
                    response(data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
};
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});


export default store;
